import React from "react";
import { Groups as GroupsIcon, Psychology as PsychologyIcon, Handshake as HandshakeIcon } from "@mui/icons-material";
import AnimatedSection from "../AnimatedSection/AnimatedSection";
import { t } from "../../i18n";

const MissionSection: React.FC = () => {
  return (
    <section className="bg-gradient-to-br from-primaryGreen via-primaryGreen to-[#8c52ff] py-12 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto text-center">
        <AnimatedSection>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold bg-gradient-to-r text-white bg-clip-text text-transparent mb-6">{t("mission.title")}</h2>

          <p className="text-lg sm:text-xl md:text-2xl text-white max-w-3xl mx-auto mb-10 sm:mb-12">{t("mission.description")}</p>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-10 mb-10 sm:mb-20">
          {/* Kart 1 */}
          <AnimatedSection delay={200}>
            <div className="bg-white rounded-xl h-full  shadow-md px-6 sm:px-8 py-6 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-300">
              <div className="flex flex-col items-center justify-center gap-1 mb-4">
                <GroupsIcon className="text-primaryGreen !w-16 !h-16" />
                <h3 className="text-xl sm:text-2xl font-semibold text-primaryGreen">{t("mission.card1.title")}</h3>
              </div>
              <p className="text-gray-600 text-base sm:text-lg">{t("mission.card1.description")}</p>
            </div>
          </AnimatedSection>

          {/* Kart 2 */}
          <AnimatedSection delay={400}>
            <div className="bg-white rounded-xl h-full shadow-md px-6 sm:px-8 py-6 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-300">
              <div className="flex flex-col items-center justify-center gap-2 mb-4">
                <PsychologyIcon className="text-primaryGreen !w-16 !h-16" />
                <h3 className="text-xl sm:text-2xl font-semibold text-primaryGreen">{t("mission.card2.title")}</h3>
              </div>
              <p className="text-gray-600 text-base sm:text-lg">{t("mission.card2.description")}</p>
            </div>
          </AnimatedSection>

          {/* Kart 3 */}
          <AnimatedSection delay={600}>
            <div className="bg-white rounded-xl h-full shadow-md px-6 sm:px-8 py-6 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-300">
              <div className="flex flex-col items-center justify-center gap-2 mb-4">
                <HandshakeIcon className="text-primaryGreen !w-16 !h-16" />
                <h3 className="text-xl sm:text-2xl font-semibold text-primaryGreen">{t("mission.card3.title")}</h3>
              </div>
              <p className="text-gray-600 text-base sm:text-lg">{t("mission.card3.description")}</p>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
